import React from "react";
import { motion } from "framer-motion";
import { MessageSquare, Search, MapPin, FileEdit, Send } from "lucide-react";

const STEPS = [
  { icon: MessageSquare, title: "Contacto Inicial",        desc: "Nos contactas por WhatsApp, teléfono o correo. Cuéntanos tu proyecto o necesidad." },
  { icon: Search,        title: "Análisis del Caso",       desc: "Evaluamos los detalles de tu situación y determinamos el servicio más adecuado para ti." },
  { icon: MapPin,        title: "Visita Técnica",          desc: "Realizamos la inspección física del inmueble o proyecto con equipo profesional especializado." },
  { icon: FileEdit,      title: "Elaboración del Servicio",desc: "Redactamos el avalúo, peritaje o dictamen con la metodología técnica y legal correspondiente." },
  { icon: Send,          title: "Entrega y Seguimiento",   desc: "Recibes tu documento oficial, con acompañamiento si necesitas apoyo en su presentación." },
];

export default function Process() {
  return (
    <section
      id="proceso"
      data-testid="process-section"
      className="relative bg-white py-24 lg:py-32 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-brand-gold" />
            <span className="label-overline">Cómo Trabajamos</span>
          </div>
          <h2 className="mt-5 font-playfair text-3xl sm:text-4xl lg:text-5xl text-brand-navy leading-[1.1] tracking-tight text-balance">
            Un proceso <span className="italic text-brand-gold">claro</span>, eficiente y transparente
          </h2>
        </div>

        {/* Desktop horizontal */}
        <div className="mt-16 hidden lg:block relative">
          {/* dashed connecting line */}
          <svg className="absolute left-0 right-0 top-8" height="2" width="100%" preserveAspectRatio="none" aria-hidden>
            <line x1="6%" y1="1" x2="94%" y2="1" stroke="#C9A84C" strokeWidth="1.5" strokeDasharray="6 8" />
          </svg>

          <ol className="relative grid grid-cols-5 gap-6">
            {STEPS.map((s, i) => (
              <motion.li
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.1, ease: "easeOut" }}
                className="text-center"
                data-testid={`process-step-${i}`}
              >
                <div className="relative mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-brand-navy text-brand-gold shadow-[0_10px_30px_-12px_rgba(27,42,74,0.45)]">
                  <span className="font-playfair text-xl">{String(i + 1).padStart(2, "0")}</span>
                  <span className="absolute inset-0 rounded-full border border-brand-gold/40 scale-125" />
                </div>
                <div className="mt-6 flex justify-center">
                  <s.icon size={20} className="text-brand-gold" strokeWidth={1.6} />
                </div>
                <h3 className="mt-3 font-playfair text-lg text-brand-navy">{s.title}</h3>
                <p className="mt-2 font-inter text-sm text-brand-mute leading-relaxed px-2">{s.desc}</p>
              </motion.li>
            ))}
          </ol>
        </div>

        {/* Mobile vertical */}
        <ol className="mt-14 lg:hidden relative pl-10 border-l border-dashed border-brand-gold/50">
          {STEPS.map((s, i) => (
            <motion.li
              key={s.title}
              initial={{ opacity: 0, x: 24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.08, ease: "easeOut" }}
              className="relative pb-10 last:pb-0"
            >
              <span className="absolute -left-[52px] flex h-12 w-12 items-center justify-center rounded-full bg-brand-navy text-brand-gold font-playfair">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="flex items-center gap-2 text-brand-gold">
                <s.icon size={18} strokeWidth={1.6} />
                <span className="font-mont text-[10px] uppercase tracking-[0.22em]">Paso {i + 1}</span>
              </div>
              <h3 className="mt-2 font-playfair text-xl text-brand-navy">{s.title}</h3>
              <p className="mt-2 font-inter text-sm text-brand-mute leading-relaxed">{s.desc}</p>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
}
